import React from 'react';
import GradingIcon from '@mui/icons-material/Grading';
import { Link } from 'react-router-dom';
import {
  Box,
  Button,
  IconButton,
  Link as MuiLink,
  Typography,
} from '@mui/material';

import AddIcon from '@mui/icons-material/Add';

import _kebabCase from 'lodash/kebabCase';
import _startCase from 'lodash/startCase';

import FormAvatar from './FormAvatar';
import FormPaper from './FormPaper';
import { ReportType } from '../core/api/clients';
import SvgIconHelpDocument from '../assets/svg/SvgIconHelpDocument';

type FormCardProps = {
  children: React.ReactNode,
  color: string | null | undefined,
  title: ReportType | undefined,
  rootRoute: string | null | undefined,
  disableLink?: boolean,
  disableAvatar?: boolean,
  disableNew?: boolean,
};

function FormCard({
  children,
  color,
  title,
  rootRoute,
  disableLink,
  disableAvatar,
  disableNew,
}: FormCardProps) {
  return (
    <FormPaper color={color}>
      <Box display="flex" alignItems="center" sx={{ mt: 1, mb: 2 }}>
        <Box display="flex" alignItems="center" flexGrow={1}>
          {!disableAvatar && (
            <FormAvatar color={color} title={title} />
          )}
          <Typography sx={{ mr: 2 }} variant="h5">
            {disableLink || rootRoute === null ? _startCase(title) : (
              <MuiLink href={rootRoute} underline="hover">
                {_startCase(title)}
              </MuiLink>
            )}
          </Typography>
        </Box>
        <Box>
          <IconButton
            href={`api/metadata/help?formName=${_kebabCase(title)}-help.pdf`}
            target="_blank"
            sx={{ mr: 3 }}
          >
            <SvgIconHelpDocument />
          </IconButton>
          {!disableNew && (
            <Button
              component={Link}
              to={`${rootRoute}/new`}
              endIcon={<AddIcon />}
              variant="outlined"
            >
              New
            </Button>
          )}
        </Box>
      </Box>
      {children}
    </FormPaper>
  );
}

export default FormCard;
